import React from 'react';

const HowItWorks = () => {
  return (
    <section className="relative w-full py-16 sm:py-20 md:py-24 lg:py-28 overflow-hidden">
      {/* Background Text */}
      <div className="absolute top-0 left-0 right-0 pointer-events-none">
        <h2
          className="text-[150px] sm:text-[300px] md:text-[500px] lg:text-[952px] font-['BD_Megalona_DEMO_Personal_Use_Only'] italic lowercase text-[#ffefef]/50 leading-none home-bg-text-lineheight"
        >
          modern
        </h2>
      </div>

      <div className="relative w-full max-w-[1360px] mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <p className="text-sm sm:text-base font-semibold uppercase tracking-wide bg-gradient-to-r from-[#8a216b] to-[#f03f16] bg-clip-text text-transparent mb-3 sm:mb-4">
            modern path
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[48px] font-semibold text-text-primary capitalize mb-4 sm:mb-5 md:mb-6">
            How It Works &#123;Without The Cringe&#125;
          </h2>
          <p className="text-base sm:text-lg text-text-primary/60 max-w-3xl mx-auto">
            Designed specifically to keep parents happy while giving you full control over how you find and interact with potential matches.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {/* Feature 1 */}
          <div
            className="bg-gradient-to-b from-[#fff7f8] to-white border border-primary-brand/40 rounded-[36px] p-6 sm:p-8 shadow-[6px_6px_1px_#8f2368] transition-all"
          >
            <img
              src="/images/img_fluent_form_32_light.png"
              alt="Create Profile"
              className="w-24 sm:w-28 md:w-[120px] h-auto mb-6 sm:mb-8"
            />
            <h3 className="text-2xl sm:text-3xl md:text-[28px] font-semibold text-text-dark mb-3 sm:mb-4">
              Create Authentic Bio
            </h3>
            <p className="text-sm sm:text-base text-text-tertiary leading-relaxed">
              Fill in your background with zero fluff. Specify your Gothram, native village, profession, and modern family values.
            </p>
          </div>

          {/* Feature 2 */}
          <div
            className="bg-gradient-to-b from-[#fff7f8] to-white border border-primary-brand/40 rounded-[36px] p-6 sm:p-8 shadow-[6px_6px_1px_#a92a51] transition-all"
          >
            <img
              src="/images/img_mage_filter_square.png"
              alt="Filters"
              className="w-24 sm:w-28 md:w-[120px] h-auto mb-6 sm:mb-8"
            />
            <h3 className="text-2xl sm:text-3xl md:text-[28px] font-semibold text-text-dark mb-3 sm:mb-4">
              Interactive Filters
            </h3>
            <p className="text-sm sm:text-base text-text-tertiary leading-relaxed">
              Filter by location, horoscope matches (Porutham Check), family values, or professional background easily.
            </p>
          </div>

          {/* Feature 3 */}
          <div
            className="bg-gradient-to-b from-[#fff7f8] to-white border border-primary-brand/40 rounded-[36px] p-6 sm:p-8 shadow-[6px_6px_1px_#8a216b] transition-all flex flex-col justify-between"
          >
            <div>
              <img
                src="/images/img_icon_park_outline_family.png"
                alt="Family Connect"
                className="w-24 sm:w-28 md:w-[120px] h-auto mb-6 sm:mb-8"
              />
              <h3 className="text-2xl sm:text-3xl md:text-[28px] font-semibold text-text-dark mb-3 sm:mb-4">
                Family Connect
              </h3>
              <p className="text-sm sm:text-base text-text-tertiary leading-relaxed">
                Connect directly with verified families, start chat threads, schedule video sessions, and arrange offline meets securely.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;